'use strict';

/**
 * Init Addons Logic
 */
class TWER_ADDONS {

  /**
   * Сonstructor
   *
   * @param props
   */
  constructor(props) {

      let $btnCatMobile = jQuery('.twer-mobile-menu');
      let $mobileCatMenu = jQuery('.twer-mobile-cat');
      let $select2Container = jQuery('.map-category-container');
      const $selectMapCat = jQuery('#mapCatField');

      var width = jQuery(window).width();
      jQuery(window).on('resize', function () {
        if (jQuery(this).width() !== width) {
          width = jQuery(this).width();

          if (width > 650) {
            $select2Container.show();
            $btnCatMobile.hide();
          }else{
            $select2Container.hide();
            $btnCatMobile.show();
          }

        }
      });

      $btnCatMobile.on('click', function () {
        if( jQuery(window).width() > 650 ) return false;

        $select2Container.show();
        $selectMapCat.select2('open');
      });

      $selectMapCat.on('select2:open', function (e) {
        if( jQuery(window).width() > 650 ) return false;

        $mobileCatMenu.hide();
      });

      $selectMapCat.on('select2:close', function (e) {
        if( jQuery(window).width() > 650 ) return false;

        $select2Container.hide();
        $mobileCatMenu.show();
      });



      /**
       * Fix Height Issue on mobile
       */

      function setDocHeight() {
        document.documentElement.style.setProperty('--vh', `${window.visualViewport.height / 100}px`);
      }

  }

}

export default TWER_ADDONS;

